import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7000Model } from '../kymw7000.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
type GetCatalogIdResponse = {
  TagId: string;
  TagName: string;
}[];

/**
 * 企画管理取得サービス
 * @export GetCatalogIdService
 * @class GetCatalogIdService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCatalogIdService extends PlessJsonResponderSub<GetCatalogIdResponse> {
  model: KYMW7000Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCatalogIdService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetCatalogIdService
   */
  execute(model: KYMW7000Model, f?: () => void): void {
    this.model = model;
    if (f) this.calbak = f;
    this.send('getCatalogId', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCatalogIdService
   */
  success(data: GetCatalogIdResponse) {
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
